export function isAppShellHtml(text: string): boolean {
    if (!text) return false;
    const lower = text.toLowerCase();
    return (
        lower.includes('<div id="root">') ||
        lower.includes("claranarratio app") ||
        lower.includes("/assets/index-") ||
        lower.includes("vite-plugin-pwa") ||
        lower.includes("registersw")
    );
}

export function isCorruptLocalData(text: string): boolean {
    if (!text) return false;
    const lower = text.toLowerCase();
    return (
        isAppShellHtml(text) ||
        lower.includes('<!doctype html') ||
        lower.includes('<html>') ||
        (lower.includes('<html') && lower.includes('</html>')) ||
        (lower.includes('<body') && lower.includes('</body>'))
    );
}

export function validateRawResponse(text: string | undefined): void {
    if (!text || text.trim().length === 0) {
        throw new Error("Response returned empty content.");
    }
    if (isAppShellHtml(text)) {
        throw new Error("API returned app HTML; /api route is not reaching Worker.");
    }
}

export function validateSavedText(text: string | undefined): void {
    if (!text || text.trim().length === 0) {
        throw new Error("Book text is empty.");
    }
    if (isCorruptLocalData(text)) {
        throw new Error("API returned app HTML; /api route is not reaching Worker.");
    }
}

export const validateBookText = validateSavedText;

